import { emulatorScreen, mobileScreen } from "../../../utils/styleUtils";

const styles = (theme) => ({
  verticalLinesContainer: {
    position: "absolute",
    top: "-52px",
    left: "225px",
    [emulatorScreen(theme)]: {
      top: "-35px",
      left: "150px",
    },
    [mobileScreen(theme)]: {
      top: "-25px",
      left: "100px",
    },
  },

  graphLines: {
    borderLeft: "5px solid #565656",
    borderBottom: "5px solid #565656",
    height: "330px",
    width: "460px",
    position: "relative",
    [emulatorScreen(theme)]: {
      width: "290px",
      height: "210px",
      borderWidth: "3px",
    },
    [mobileScreen(theme)]: {
      width: "200px",
      height: "150px",
      borderWidth: "3px",
    },
  },

  pLabels: {
    left: -40,  
    top: -20,
    position: 'absolute',
    color: "#003e4c",
    fontSize: 26,
    width: 20,
    height: 25,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 18,
      left: -30,  
      top: -20,
    },
  },

  graphYLable: {
    height: "18px",
    position: "absolute",
    top: "7px",
    left: "-90px",
    [emulatorScreen(theme)]: {
      height: "12px",
      left: "-60px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      left: "-50px",
    },
  },

  graphXLable: {
    height: "18px",
    position: "absolute",
    bottom: "-35px",
    right: "5px",
    [emulatorScreen(theme)]: {
      height: "12px",
      bottom: "-25px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      bottom: "-22px",
    },
  },

  qLabels: {
    right: -60,
    bottom: -60,
    zIndex: 11,
    position: 'absolute',
    color: "#003e4c",
    fontSize: 26,
    width: 20,
    height: 25,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 18,
      right: -20,
      bottom: -10,
    },
  },

  dragLineMessage: {
    height: "130px",
    position: "absolute",
    right: "-20px",
    top: "80px",
    [emulatorScreen(theme)]: {
      height: "90px",
      right: "-25px",
      top: "50px",
    },
    [mobileScreen(theme)]: {
      top: "25px",
      right: "-25px",
      height: "75px",
    },
  },

  questionMark: {
    width: "150px",
    [emulatorScreen(theme)]: {
      width: "95px",
    },
    [mobileScreen(theme)]: {
      width: "85px",
    },
  },

  arrows: {
    position: "absolute",
    height: "30px",
    top: "185px",
    left: "-50px",
    [emulatorScreen(theme)]: {
      top: "117px",
      left: "12px",
      height: "18px",
    },
    [mobileScreen(theme)]: {
      top: "84px",
      left: "8px",
      height: "10px",
    },
  },

  defaultLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    backgroundColor: "#003e4c",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  correctLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLine: {
    display: "flex",
    justifyContent: "center",
    height: "400px",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLineContainer: {
    display: "flex",
    justifyContent: "center",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    top: "28px",
    left: "-68px",
    height: "0",
    position: "absolute",
    // [emulatorScreen(theme)]: {
    //   height: "260px",
    //   width: "5px",
    // },
    // [mobileScreen(theme)]: {
    //   height: "190px",
    //   width: "4px"
    // },
  },

  fadedDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003E4C",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#003E4C",
    top: "120px",
    color: "blue",
    [emulatorScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
  },

  correctDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003e4c",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#CACDCE",
    color: "blue",
    zindex: 100,
    // border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
  },

  draggableDot: {
    transform: "rotate(45deg)",
    borderRadius: "50%",
    padding: "10px",
    color: "blue",
    border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
  },

  internationalContainerMajor: {
    // justifyContent: "center",
    justifyContent: "center",
    position: "relative",
    display: "flex",
    cursor: "pointer",
    [emulatorScreen(theme)]: {
      justifyContent: "start",
    },
  },

  internationalContainerChild: {
    position: "relative",
    display: "flex",
    height: 400,
    width: 400,

    [emulatorScreen(theme)]: {
      height: 270,
      width: 270,
    },
    [mobileScreen(theme)]: {
      height: 270,
      width: 270,
    },
  },

  line1: {
    position: "absolute",
    top: 179,
    width: "55%",
    left: 0,
    [emulatorScreen(theme)]: {
      position: "absolute",
      top: 120,
      width: "55%",
      left: 50,
    },
    [mobileScreen(theme)]: {
      position: "absolute",
      top: 120,
      width: "55%",
      left: 50,
    },
  },

  // new lines
  linenewHorzi1 : {
    height: "21%",
    top: 58,
    transform: "rotate(-90deg)",
    left: "18%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "40%",
      // top: 85,
      // left: 135,
    },
    [mobileScreen(theme)]: {
      height: "22%",
      top: 38,
      left: 49,
    },
  },

  linenewHorzi2 : {
    height: "21%",
    top: 150,
    transform: "rotate(-90deg)",
    left: "18%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "40%",
      top: 85,
      left: 135,
    },
    [mobileScreen(theme)]: {
      height: "22%",
      top: 100,
      left: 50,
    },
  },

  linenewHorzi4 : {
    height: "21%",
    top: 150,
    transform: "rotate(-90deg)",
    left: "42%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "40%",
      // top: 85,
      // left: 135,
    },
    [mobileScreen(theme)]: {
      height: "22%",
      top: 100,
      left: 114,
    },
  },

  // linenewHorzi2: {
  //   height: "55%",
  //   top: 84,
  //   transform: "rotate(-90deg)",
  //   left: "31%",
  //   position: "absolute",
  //   [emulatorScreen(theme)]: {
  //     height: "40%",
  //     top: 85,
  //     left: 135,
  //   },
  //   [mobileScreen(theme)]: {
  //     height: "40%",
  //     top: 85,
  //     left: 135,
  //   },
  // },

  linenewHorzi3 : {
    height: "21%",
    top: 245,
    transform: "rotate(-90deg)",
    left: "18%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "40%",
      // top: 85,
      // left: 135,
    },
    [mobileScreen(theme)]: {
      height: "22%",
      top: 164,
      left: 49,
    },
  },

  linenewVert1: {
    height: "21%",
    top: 105,
    left: "30.5%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "40%",
      // top: 85,
      // left: 135,
    },
    [mobileScreen(theme)]: {
      height: "22%",
      top: 71,
      left: 83,
    },
  },

  linenewVert2: {
    height: "21%",
    top: 196,
    left: "30.5%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "40%",
      // top: 85,
      // left: 135,
    },
    [mobileScreen(theme)]: {
      height: "22%",
      top: 128,
      left: 83,
    },
  },

  linenewVert3: {
    height: "21%",
    top: 293,
    left: "30.8%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "40%",
      // top: 85,
      // left: 135,
    },
    [mobileScreen(theme)]: {
      height: "22%",
      top: 196,
      left: 84,
    },
  },

  linenewVert4: {
    height: "54%",
    top: 198,
    left: "50.8%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "40%",
      // top: 85,
      // left: 135,
    },
    [mobileScreen(theme)]: {
      height: "54%",
      top: 133,
      left: 137,
    },
  },

  //end new lines

  line24: {
    height: "27%",
    top: 195,
    position: "absolute",
    marginLeft: "50%",
    paddingTop: "15%",
    zIndex: 1,
    [emulatorScreen(theme)]: {
      height: "26%",
      top: 133,
      right: 116,
    },
    [mobileScreen(theme)]: {
      height: "26%",
      top: 133,
      right: 116,
    },
  },

  line29: {
    height: "27%",
    top: 195,
    position: "absolute",
    marginLeft: "94.3%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      height: "26%",
      top: 133,
      marginLeft: "93%",
    },
    [mobileScreen(theme)]: {
      height: "26%",
      top: 133,
      marginLeft: "93%",
    },
  },

  line21: {
    height: "42%",
    top: 121,
    left: 378,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 85,
      left: 251,
    },
    [mobileScreen(theme)]: {
      top: 85,
      left: 252,
    },
  },
// start  new design for blue dotted
  BlueHoriLine1: {
    height: "23%",
    top: 55,
    left: 58,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "15%",
      // top: 87,
      // left: 136,
    },
    [mobileScreen(theme)]: {
      top: 37,
      left: 40,
      // height: "15%",
      // top: 87,
      // left: "50.49%",
    },
  },  
  BlueHoriLine2: {
    height: "23%",
    top: 147,
    left: 59,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "15%",
      // top: 87,
      // left: 136,
    },
    [mobileScreen(theme)]: {
      top: 99,
      left: 41,
      // height: "15%",
      // top: 87,
      // left: "50.49%",
    },
  },
  BlueHoriLine3: {
    height: "23%",
    top: 147,
    left: 151,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "15%",
      // top: 87,
      // left: 136,
    },
    [mobileScreen(theme)]: {
      top: 99,
      left: 103,
      // left: "50.49%",
    },
  },
  BlueHoriLine4: {
    height: "22%",
    top: 243,
    left: 58,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "15%",
      // top: 87,
      // left: 136,
    },
    [mobileScreen(theme)]: {
      top: 164.2,
      left: 40,
      // height: "15%",
      // top: 87,
      // left: "50.49%",
    },
  },

  BlueVertiLine1: {
    height: "22%",
    top: 102,
    left: 108,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "15%",
      // top: 87,
      // left: 136,
    },
    [mobileScreen(theme)]: {
      top: 69,
      left: 74,
      // height: "15%",
      // top: 87,
      // left: "50.49%",
    },
  },
  BlueVertiLine2: {
    height: "21%",
    top: 195,
    left: 109.2,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "15%",
      // top: 87,
      // left: 136,
    },
    [mobileScreen(theme)]: {
      top: 132,
      left: 74.3,
      // height: "15%",
      // top: 87,
      // left: "50.49%",
    },
  },
// end new design for blue dotted

  line15: {
    height: "16%",
    top: 128,
    left: 202,
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "15%",
      top: 87,
      left: 136,
    },
    [mobileScreen(theme)]: {
      height: "15%",
      top: 87,
      left: "50.49%",
    },
  },

  line22: {
    height: "42%",
    top: 121,
    left: 378,
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "39%",
      top: 85,
      width: 17,
      left: 251.2,
    },
    [mobileScreen(theme)]: {
      height: "40%",
      top: 84,
      left: "93.6%",
    },
  },

  line2: {
    position: "absolute",
    top: 189,
    width: "25.5%",
    left: 111,
    [emulatorScreen(theme)]: {
      top: 125,
      left: 75,
      width: "26%",
      height: "2%",
    },
    [mobileScreen(theme)]: {
      top: "46.71%",
      left: 75,
      height: "1.5%",
    },
  },

  line18: {
    height: "16%",
    top: 191,
    left: "50.45%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "17%",
      top: 129,
      left: 135,
    },
    [mobileScreen(theme)]: {
      height: "17%",
      top: 129,
      left: "50.1%",
    },
  },

  line5: {
    position: "absolute",
    top: 189,
    width: "19.7%",
    left: 216,
    [emulatorScreen(theme)]: {
      top: 126.5,
      left: 145,
    },
    [mobileScreen(theme)]: {
      width: "21.7%",
      top: 126,
      left: 143,
    },
  },

  line28: {
    height: "19%",
    top: 195,
    position: "absolute",
    marginLeft: "50%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      top: 133,
    },
    [mobileScreen(theme)]: {
      top: 133,
      marginLeft: "49.9%",
    },
  },

  line9: {
    height: "41%",
    top: 195,
    right: 89,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 131,
      right: 60,
    },
    [mobileScreen(theme)]: {
      top: 131,
      right: 60,
    },
  },

  line26: {
    height: "18.5%",
    top: 257,
    position: "absolute",
    left: 377,
    [emulatorScreen(theme)]: {
      top: 173,
      left: 250.45,
    },
    [mobileScreen(theme)]: {
      top: 173,
      left: 251.45,
    },
  },

  line8: {
    height: "41%",
    top: 195,
    right: 89,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 131,
      right: 60,
    },
    [mobileScreen(theme)]: {
      top: 131,
      right: 60,
    },
  },

  line3: {
    position: "absolute",
    top: 189,
    width: "25.5%",
    left: 112,
    [emulatorScreen(theme)]: {
      top: 127,
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 126,
      left: 75,
    },
  },

  line6: {
    position: "absolute",
    top: 189,
    width: "25.5%",
    left: 215,
    [emulatorScreen(theme)]: {
      top: 127,
      left: 144,
    },
    [mobileScreen(theme)]: {
      top: 126,
      left: 144,
    },
  },

  line19: {
    height: "16%",
    top: 193,
    left: 212,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 128,
      left: 142.5,
    },
    [mobileScreen(theme)]: {
      top: 128,
      left: 141.9,
      width: "2%",
    },
  },

  // start design green dotted lines
  greenHoriLine1: {
    height: "22%",
    top: 56,
    left: 72,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "18%",
      // top: 86,
      // left: 141.5,
    },
    [mobileScreen(theme)]: {
      top: 37,
      left: 49,
      // height: "18%",
      // top: 86,
      // left: 142.5,
    },
  },
  greenHoriLine2: {
    height: "24%",
    top: 144.5,
    left: 76,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "18%",
      // top: 86,
      // left: 141.5,
    },
    [mobileScreen(theme)]: {
      // height: "18%",
      top: 97.2,
      left: 51.5,
    },
  },
  greenHoriLine3: {
    height: "21.5%",
    top: 244,
    left: 71,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "18%",
      // top: 86,
      // left: 141.5,
    },
    [mobileScreen(theme)]: {
      // height: "18%",
      top: 165,
      left: 48,
    },
  },
  greenHoriLine4: {
    height: "22.5%",
    top: 147.5,
    left: 165,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "18%",
      // top: 86,
      // left: 141.5,
    },
    [mobileScreen(theme)]: {
      // height: "18%",
      top: 99.5,
      left: 114,
    },
  },

  greenVertiLine1: {
    height: "21.5%",
    top: 104,
    left: 122,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "18%",
      // top: 86,
      // left: 141.5,
    },
    [mobileScreen(theme)]: {
      // height: "18%",
      top: 74,
      left: 83,
    },
  },
  greenVertiLine2: {
    height: "21.5%",
    top: 194,
    left: 122,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "18%",
      // top: 86,
      // left: 141.5,
    },
    [mobileScreen(theme)]: {
      // height: "18%",
      top: 126,
      left: 83,
    },
  },
  // start design green dotted lines

  line10: {
    height: "34%",
    top: 195,
    left: "74.45%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 131,
      left: 201.5,
    },
    [mobileScreen(theme)]: {
      top: 131,
      left: 197,
      width: "4%",
    },
  },

  line25: {
    height: "19%",
    top: 195,
    position: "absolute",
    left: "52.9%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      top: 132,
      left: 142,
    },
    [mobileScreen(theme)]: {
      top: 132,
      left: 142,
    },
  },

  line27: {
    height: "18.5%",
    top: 257,
    position: "absolute",
    left: 389,
    [emulatorScreen(theme)]: {
      top: 173,
      left: 258,
    },
    [mobileScreen(theme)]: {
      top: 173,
      left: 256,
      width: "3%",
    },
  },

  line23: {
    height: "34%",
    top: 125,
    left: 389,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 85,
      left: 251.5,
      height: "32%",
      width: 17,
    },
    [mobileScreen(theme)]: {
      top: 87,
      width: "4%",
      left: 255.5,
    },
  },

  line4: {
    position: "absolute",
    top: 188,
    width: "25.5%",
    left: 111,
    [emulatorScreen(theme)]: {
      top: 126,
      height: "2%",
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 126,
      left: 75,
    },
  },

  line7: {
    position: "absolute",
    top: 189,
    width: "20%",
    left: 215,
    [emulatorScreen(theme)]: {
      top: 126,
      left: 144,
    },
    [mobileScreen(theme)]: {
      top: 127,
      left: 144,
    },
  },

  line17: {
    height: "17%",
    top: 122,
    left: "52.9%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "18%",
      top: 77,
      left: 141.5,
    },
    [mobileScreen(theme)]: {
      height: "18%",
      top: 77,
      left: 141.5,
    },
  },

  line20: {
    height: "17%",
    top: 189,
    left: "52.9%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 130,
      left: 142,
    },
    [mobileScreen(theme)]: {
      top: 130,
      left: 142,
    },
  },

  shape1Major: {
    width: 387,
    overflow: "hidden",
    top: 41.5,
    left: 107,
    position: "absolute",
    zIndex: 3,
    height: 82,
    clipPath: "polygon(28% 100%, 72% 100%, 100% 0, 0 0)",
    shapeOutside: "polygon(28% 100%, 72% 100%, 100% 0, 0 0)",

    [emulatorScreen(theme)]: {
      width: 266,
      top: 26.5,
      left: 70,
      height: 57,
    },
    [mobileScreen(theme)]: {
      width: 266,
      top: 26.5,
      left: 70,
      height: 57,
    },
  },

  shape1Child: {
    height: 78,
    [emulatorScreen(theme)]: {
      height: 53,
    },
    [mobileScreen(theme)]: {
      height: 53,
    },
  },

// new divs
  shape2Major: {
    width: 98,
    overflow: "hidden",
    top: 13,
    left: 44,
    position: "absolute",
    zIndex: 3,
    height: 84.5,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 100,
      top: 31,
      left: 75,
      height: 53,
    },
    [mobileScreen(theme)]: {
      width: 93,
      top: 10,
      left: 39,
      height: 47,
    },
  },

  shape2Child: {
    height: "100%",
    width: "100%",
    // marginTop: 5,
    [emulatorScreen(theme)]: {
      height: 48,
      width: "65%",
    },
    [mobileScreen(theme)]: {
      marginTop: 4,
      height: "100%",
      width: "65%",
    },
  },

  shape3Major: {
    width: 102.5,
    overflow: "hidden",
    top: 97,
    left: 44,
    position: "absolute",
    zIndex: 3,
    height: 89.5,
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    [emulatorScreen(theme)]: {
      width: 65,
      top: 32,
      left: 266,
      height: 51.5,
    },
    [mobileScreen(theme)]: {
      width: 57.5,
      top: 55,
      left: 39,
      height: 50,
    },
  },

  shape3Child: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      
    },
  },

  shape4Major: {
    width: 102.3,
    overflow: "hidden",
    top: 188,
    left: 44,
    position: "absolute",
    zIndex: 3,
    height: 88,
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    [emulatorScreen(theme)]: {
      width: 67.5,
      top: 81.5,
      left: 75,
      height: 45.5,
    },
    [mobileScreen(theme)]: {
      width: 57.5,
      top: 105,
      left: 39,
      height: 48,
    },
  },

  shape4Child: {
    height: "100%",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
    },
  },

  shape5Major: {
    width: 98,
    overflow: "hidden",
    top: 281,
    left: 44,
    position: "absolute",
    zIndex: 3,
    height: 81.5,
    clipPath: "polygon(0 0, 0% 100%, 100% 0)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 0)",
    [emulatorScreen(theme)]: {
      width: 54,
      top: 82.5,
      left: 144.5,
      height: 44.5,
    },
    [mobileScreen(theme)]: {
      width: 56,
      top: 156,
      left: 39,
      height: 43,
    },
  },

  shape5Child: {
    height: "100%",
    // float: "left",
    // height: 60,
    // clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    // shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    // width: "100%",
    // marginTop: 5,
    [emulatorScreen(theme)]: {
      // height: 40,
    },
    [mobileScreen(theme)]: {
      // height: 40,
    },
  },

  shape6Major: {
    width: 98.5,
    overflow: "hidden",
    top: 191,
    left: 151.5,
    position: "absolute",
    zIndex: 3,
    height: 82.5,
    clipPath: "polygon(0 0, 0% 100%, 100% 0)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 0)",
    [emulatorScreen(theme)]: {
      width: 114,
      top: 81.5,
      left: 146,
      height: 44,
    },
    [mobileScreen(theme)]: {
      width: 56,
      top: 108,
      left: 99.5,
      height: 44,
    },
  },

  shape6Child: {
    width: "100%",
    height: "100%",
    [emulatorScreen(theme)]: {
      // height: 40,
    },
    [mobileScreen(theme)]: {
      // height: 40,
    },
  },

  shape7Major: {
    width: 100,
    overflow: "hidden",
    top: 104,
    left: 151,
    position: "absolute",
    zIndex: 3,
    height: 82.5,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 55,
      top: 84,
      left: "75.5%",
      height: 84,
    },
    [mobileScreen(theme)]: {
      width: 56.5,
      top: 61,
      left: 99.5,
      height: 44,
    },
  },

  shape7Child: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      // height: 80,
    },
    [mobileScreen(theme)]: {
      // height: 80,
    },
  },
  // end
  shape8Major: {
    width: 98,
    overflow: "hidden",
    top: "30.85%",
    left: 393,
    position: "absolute",
    zIndex: 3,
    height: 205,
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 64%)",
    shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 0 64%)",
    [emulatorScreen(theme)]: {
      width: 68,
      top: 81.5,
      left: 261.4,
      height: 139,
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 64%)",
      shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 0 64%)",
    },
    [mobileScreen(theme)]: {
      width: 68,
      top: 81.5,
      left: 262,
      height: 139,
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 63%)",
      shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 0 63%)",
    },
  },

  shape8Child: {
    float: "left",
    height: 199,
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 64%)",
    shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 0 64%)",
    width: "100%",
    marginTop: 5,
    [emulatorScreen(theme)]: {
      height: 135,
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 63%)",
      shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 0 63%)",
    },
    [mobileScreen(theme)]: {
      height: 135,
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 63%)",
      shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 0 63%)",
    },
  },

  shape9Major: {
    width: 101,
    overflow: "hidden",
    top: 188,
    left: 111,
    position: "absolute",
    zIndex: 3,
    height: 140,
    clipPath: "polygon(0 0, 100% 0, 100% 46%, 0 100%)",
    shapeOutside: "polygon(0 0, 100% 0, 100% 46%, 0 100%)",
    [emulatorScreen(theme)]: {
      width: 67.5,
      top: 124.5,
      left: 75,
      height: 97,
      clipPath: "polygon(0 0, 100% 0, 100% 48%, 0 100%)",
      shapeOutside: "polygon(0 0, 100% 0, 100% 48%, 0 100%)",
    },
    [mobileScreen(theme)]: {
      width: 68,
      top: 124.5,
      left: 75,
      height: 97,
      clipPath: "polygon(0 0, 100% 0, 100% 48%, 0 100%)",
      shapeOutside: "polygon(0 0, 100% 0, 100% 48%, 0 100%)",
    },
  },

  shape9Child: {
    float: "left",
    height: 135,
    clipPath: "polygon(0 0, 100% 0, 100% 46.5%, 0 100%)",
    shapeOutside: "polygon(0 0, 100% 0, 100% 46.5%, 0 100%)",
    width: "100%",
    marginTop: 5,
    [emulatorScreen(theme)]: {
      height: 93,
    },
    [mobileScreen(theme)]: {
      height: 93,
    },
  },

  shape10Major: {
    width: 83,
    overflow: "hidden",
    top: 188,
    left: "53.8906%",
    position: "absolute",
    zIndex: 3,
    height: 62,
    clipPath: "polygon(0 0, 0% 100%, 100% 0)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 0)",
    [emulatorScreen(theme)]: {
      width: 61,
      top: 124,
      left: 145,
      height: 45,
    },
    [mobileScreen(theme)]: {
      width: 59,
      top: 124.5,
      left: 145,
      height: 45,
    },
  },

  shape10Child: {
    float: "left",
    height: 57,
    clipPath: "polygon(0 0, 0% 100%, 100% 0)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 0)",
    width: "100%",
    marginTop: 5,
    [emulatorScreen(theme)]: {
      height: 40,
    },
    [mobileScreen(theme)]: {
      height: 40,
    },
  },

  shape11Major: {
    width: 94,
    overflow: "hidden",
    top: 256,
    left: 118,
    position: "absolute",
    zIndex: 3,
    height: 75,
    clipPath: "polygon(0 100%, 100% 100%, 100% 0)",
    shapeOutside: "polygon(0 100%, 100% 100%, 100% 0)",
    [emulatorScreen(theme)]: {
      width: 66,
      top: 171.5,
      left: 77,
      height: 52,
    },
    [mobileScreen(theme)]: {
      width: 66,
      top: 171,
      left: 77,
      height: 52,
    },
  },

  shape11Child: {
    float: "left",
    height: 70,
    clipPath: "polygon(0 100%, 100% 100%, 100% 0)",
    shapeOutside: "polygon(0 100%, 100% 100%, 100% 0)",
    width: "100%",
    marginTop: 5,
    [emulatorScreen(theme)]: {
      height: 48,
    },
    [mobileScreen(theme)]: {
      height: 48,
    },
  },

  shape12Major: {
    width: 82,
    overflow: "hidden",
    top: 191,
    left: 216,
    position: "absolute",
    zIndex: 3,
    height: 140,
    clipPath: "polygon(0 46%, 100% 0, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(0 46%, 100% 0, 100% 100%, 0% 100%)",
    [emulatorScreen(theme)]: {
      width: 56.5,
      top: 127.5,
      left: 145.4,
      height: 97,
    },
    [mobileScreen(theme)]: {
      width: 56.3,
      top: 127,
      left: 145,
      height: 97,
    },
  },

  shape12Child: {
    float: "left",
    height: 135,
    clipPath: "polygon(0 46%, 100% 0, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(0 46%, 100% 0, 100% 100%, 0% 100%)",
    width: "100%",
    marginTop: 5,
    [emulatorScreen(theme)]: {
      height: 91,
    },
    [mobileScreen(theme)]: {
      height: 91,
    },
  },

  shape13Major: {
    width: "22%",
    overflow: "hidden",
    top: 190,
    left: "75.4%",
    position: "absolute",
    zIndex: 3,
    height: 141,
    clipPath: "polygon(0 0, 100% 47.7%, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(0 0, 100% 47.7%, 100% 100%, 0% 100%)",
    [emulatorScreen(theme)]: {
      width: 54.5,
      top: 127,
      left: 204,
      height: 96.5,
    },
    [mobileScreen(theme)]: {
      width: 55.5,
      top: 126,
      left: 203.8,
      height: 97,
    },
  },

  shape13Child: {
    float: "left",
    height: 136,
    clipPath: "polygon(0 0, 100% 47.7%, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(0 0, 100% 47.7%, 100% 100%, 0% 100%)",
    width: "100%",
    marginTop: 5,
    [emulatorScreen(theme)]: {
      clipPath: "polygon(0 0, 100% 44%, 100% 100%, 0% 100%)",
      height: 92,
    },
    [mobileScreen(theme)]: {
      clipPath: "polygon(0 0, 100% 44.7%, 100% 100%, 0% 100%)",
      shapeOutside: "polygon(0 0, 100% 44.7%, 100% 100%, 0% 100%)",
      height: 92,
    },
  },

  shape14Major: {
    width: 92,
    overflow: "hidden",
    top: 257,
    left: 393,
    position: "absolute",
    zIndex: 3,
    height: 74,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 68,
      top: 170,
      left: 261,
      height: 53.5,
    },
    [mobileScreen(theme)]: {
      width: 67,
      top: 169,
      left: "97.01%",
      height: 54,
    },
  },

  shape14Child: {
    float: "left",
    height: 69,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    width: "100%",
    marginTop: 5,
    [emulatorScreen(theme)]: {
      height: 50,
    },
    [mobileScreen(theme)]: {
      height: 50,
    },
  },

  labelText: {
    margin: 10, color: "#003e4c", fontSize: 22, width: 20, height: 25, zIndex: 1,
    [mobileScreen(theme)]: {
      fontSize: 14,
    },
  },

  // center dot
   waveDot: {
    background: "#003e4c", fontSize: 28, height: 30, width: 30, fontWeight: 600, borderRadius: "50%", alignSelf: "center", marginLeft: "20.5%", position: "absolute", marginTop: "-3%", zIndex: 1,
    [mobileScreen(theme)]: {
      marginTop: "-17%",
      marginLeft: "46.5%",
      height: 25, width: 25,
    },
  },
  labelWaveCircle: {
    left: 0, bottom: -27, position: "absolute", zIndex: 1, width: 40, height: 40, border: "5px solid #00b1d9", borderRadius: "50%",
    [mobileScreen(theme)]: {
      width: 30, height: 30, left: 65, bottom: -20
    },
  },

  upperDot: {
    background: "#003e4c", fontSize: 28, height: 20, width: 20, fontWeight: 600, borderRadius: "50%", top: "26.5%", left: "39%", position: "absolute", marginTop: "-3%", zIndex: 1,
    [mobileScreen(theme)]: {
      top: "21.5%", left: "27.5%",
    },
  },
  lowerDot: {
    background: "#003e4c", fontSize: 28, height: 20, width: 20, fontWeight: 600, borderRadius: "50%", top: "72%", left: "39%", position: "absolute", marginTop: "-3%", zIndex: 1,
    [mobileScreen(theme)]: {
      top: "57%", left: "27.8%",
    },
  }
});
export default styles;
